const CAROUSEL_ITEMS = [
  {
    title: '2026暑期档动作巨献',
    desc: '今年夏天最值得期待的动作大片合集，燃爆整个暑假',
    img: 'https://readdy.ai/api/search-image?query=epic%20summer%20action%20movie%20scene%20with%20explosive%20visuals%2C%20fast%20cars%20and%20dramatic%20stunts%2C%20warm%20orange%20and%20golden%20cinematic%20lighting%2C%20intense%20atmosphere%2C%20dark%20moody%20background%2C%20no%20text%20or%20logos&width=800&height=450&seq=carousel-action-01&orientation=landscape',
    tag: '暑期必看',
  },
  {
    title: '豆瓣9分以上神作盘点',
    desc: '那些年我们反复刷了无数遍的满分经典',
    img: 'https://readdy.ai/api/search-image?query=classic%20cinema%20moment%20with%20dramatic%20lighting%20on%20a%20vintage%20film%20set%2C%20golden%20age%20Hollywood%20aesthetic%2C%20warm%20sepia%20tones%2C%20elegant%20composition%2C%20timeless%20atmosphere%2C%20no%20text%20or%20logos&width=800&height=450&seq=carousel-classic-02&orientation=landscape',
    tag: '经典重温',
  },
  {
    title: '国产科幻电影崛起之路',
    desc: '从流浪地球到三体，国产科幻的里程碑时刻',
    img: 'https://readdy.ai/api/search-image?query=futuristic%20Chinese%20sci%20fi%20megastructure%20with%20massive%20space%20station%20and%20neon%20lights%2C%20epic%20scale%2C%20dark%20cosmic%20background%2C%20atmospheric%20haze%2C%20cinematic%20lighting%2C%20no%20text%20or%20logos&width=800&height=450&seq=carousel-scifi-03&orientation=landscape',
    tag: '国产之光',
  },
  {
    title: '周星驰喜剧全集回顾',
    desc: '从赌圣到功夫，重温星爷的每一部经典喜剧',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20style%20comedic%20scene%20with%20vibrant%20colors%20and%20warm%20lighting%2C%20nostalgic%2090s%20aesthetic%2C%20playful%20atmosphere%2C%20rich%20golden%20tones%2C%20cinematic%20composition%2C%20no%20text%20or%20logos&width=800&height=450&seq=carousel-comedy-04&orientation=landscape',
    tag: '喜剧专场',
  },
  {
    title: '悬疑电影烧脑专题',
    desc: '让你看到最后一秒还在猜结局的高分悬疑片',
    img: 'https://readdy.ai/api/search-image?query=mysterious%20dimly%20lit%20room%20with%20dramatic%20single%20light%20source%2C%20noir%20atmosphere%2C%20shadows%20and%20silhouettes%2C%20tense%20mood%2C%20cinematic%20depth%20of%20field%2C%20warm%20amber%20highlights%20on%20dark%20background%2C%20no%20text&width=800&height=450&seq=carousel-suspense-05&orientation=landscape',
    tag: '烧脑特辑',
  },
  {
    title: '动画电影全家欢精选',
    desc: '从皮克斯到吉卜力，适合全家一起看的动画佳作',
    img: 'https://readdy.ai/api/search-image?query=beautiful%20animated%20dreamy%20landscape%20with%20soft%20pastel%20colors%2C%20floating%20lanterns%20and%20magical%20forest%2C%20warm%20golden%20light%2C%20whimsical%20atmosphere%2C%20cinematic%20composition%2C%20no%20text%20or%20logos&width=800&height=450&seq=carousel-anime-06&orientation=landscape',
    tag: '合家欢',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精心策划的观影专题，发现你的下一部心头好
          </p>
        </div>

        {/* All 6 items displayed in a grid - no carousel behavior */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block bg-background-200/40 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-300/30">
                <img
                  src={item.img}
                  alt={`五姑娘影院${item.title}`}
                  title={`五姑娘影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/80 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/80 text-background-950 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}